import { Icon } from "web/components"

export default function EventCreated({ event }) {
  return (
    <>
      <Icon name="plus-circle" outline="true" />{" "}
      <span>
        {`${event.creator} added a new ${event.recordable_type.toLowerCase()}:`}
        &nbsp;
        <b>{event.recordable_name}</b>
      </span>
    </>
  )
}
